module.exports = __webpack_public_path__ + "media/images/japan/intro_japanese_word-d1376dd7a75b1dce9f23a8f2b38826b1.svg";